module.exports = __webpack_public_path__ + "static/media/equals.9af95fcb.svg";